<template>
  <div ref="editor"></div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

export default {
  name: 'RTEditor',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.quill = new Quill(this.$refs.editor, {
      theme: 'snow',
      modules: {
        toolbar: [
          [
            { header: [1, 2, false] }, 'bold', 'italic', 'underline',
            { color: [] }, 'link', { list: 'ordered' }, { list: 'bullet' }, 'clean'
          ]
        ]
      }
    })

    this.setEditorContent(this.modelValue)
  },
  methods: {
    setEditorContent (content) {
      if (!content) {
        this.quill.setText('')
        return
      }
      // Prevent Quill from normalizing lists
      this.quill.clipboard.dangerouslyPasteHTML(content, 'silent')
    },
    getContent () {
      return this.quill.root.innerHTML
    }
  },
  watch: {
    modelValue (newValue) {
      if (newValue !== this.getContent()) {
        this.setEditorContent(newValue)
      }
    }
  }
}
</script>

<style>
.ql-toolbar {
  border-radius: 0.375rem 0.375rem 0rem 0rem;
}

.ql-container {
  height: 120px;
  background-color: #ffffff;
  border-radius: 0rem 0rem 0rem 0rem;
}

.quill-invalid-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

</style>

<style scoped>
/* Link-Tooltip Position fixieren */
:deep(.ql-tooltip[data-mode="link"]) {
  left: 0px !important;        /* oder ein anderer Wert */
  transform: translateX(0) !important;
}

/* Optional: Tooltip immer unter dem Cursor */
:deep(.ql-tooltip.ql-editing) {
  margin-left: 0 !important;
}
</style>
